// src/utils/bitsetData.js

export const bitsetString = {
  53: "P. Atk",
  54: "M. Atk",
  55: "P. Def",
  56: "M. Def",
  57: "Atk Spd",
  58: "Cast Spd",
  59: "Mov Spd",
  60: "Accuracy",
  61: "Evasion",
  62: "M. Acc",
  70: "Strength",
  71: "Vitality",
  72: "Dexterity",
  73: "Agility",
  74: "Int",
  75: "Wisdom",
  76: "Luck",
  1253: "Magic Resist",
  7101: "Strength",
  7102: "Vitality",
  7103: "Agility",
  7104: "Dexterity",
  7105: "Int.",
  7106: "Wisdom",
  7107: "Luck",
  7108: "P. Atk",
  7109: "M. Atk",
  7110: "P. Def",
  7111: "M. Def",
  7112: "Atk Spd",
  7113: "Cast Spd.",
  7114: "Mov. Spd.",
  7115: "Accuracy",
  7116: "M. Acc",
  7117: "Critical Rate",
  7118: "Block Per.",
  7119: "Block Def.",
  7120: "Evasion",
  7121: "M. Res.",
  7122: "MAX HP",
  7123: "MAX MP",
  7124: "MAX SP",
  7125: "HP Recov.",
  7126: "MP Recov.",
  7127: "SP Recov.",
  7128: "HP Regen.",
  7129: "MP Regen.",
  7130: "Max. Wt.",
  7131: "Non-Elemental Resistance",
  7132: "Fire Resistance",
  7133: "Water Resistance",
  7134: "Air Resistance",
  7135: "Earth Resistance",
  7136: "Holy Resistance",
  7137: "Darkness Resistance",
  7138: "Non-Elemental Lasting Damage",
  7139: "Fire Lasting Damage",
  7140: "Water Lasting Damage",
  7141: "Air Lasting Damage",
  7142: "Earth Lasting Damage",
  7143: "Holy Lasting Damage",
  7144: "Shade Lasting Damage",
  7145: "Non-Elemental Additional Damage",
  7146: "Fire Additional Damage",
  7147: "Water Additional Damage",
  7148: "Air Additional Damage",
  7149: "Earth Additional Damage",
  7150: "Holy Additional Damage",
  7151: "Shade Additional Damage",
  7152: "Critical Power",
  7238: "Perf. Block #@Pblock_chance@#<BR>",
  7239: "P. Ignore #@ADef_ignore@#<BR>",
  7240: "M. Ignore #@MDef_ignore@#<BR>",
  7241: "P. Pierce #@ADem_penetration@#<BR>",
  7242: "M. Pierce #@MDem_Penetration@#<BR>",
  7250: "Increase the level of all skills",
  7251: "Decrease the cooldown time of all skills",
  7252: "Decrease the casting time of all skills",
  7253: "Increase the probability of double attacks during basic attacks",
  7254: "Decrease the duration of all debuffs",
  7255: "Increase the ability of creatures",
  7258: "Amplify Ability of Equipped Boss Card",
  7259: "Increase Max HP/MP",
  7500: "Misc",
  7501: "Misc Weapon",
  7502: "One Handed Sword",
  7503: "Two Handed Sword",
  7504: "Dagger",
  7505: "Two Handed Spear",
  7506: "Two Handed Axe",
  7507: "One Handed Mace",
  7508: "Two Handed Mace",
  7509: "Long Bow",
  7510: "Short Bow",
  7511: "Crossbow",
  7512: "One Handed Staff",
  7513: "Two Handed Staff",
  7514: "One Handed Axe",
  7515: "Universal Armor",
  7516: "Warrior Armor",
  7517: "Hunter Armor",
  7518: "Mage Armor",
  7519: "Summoner Armor",
  7520: "Universal Shield",
  7521: "Universal Helmet",
  7522: "Warrior Helmet",
  7523: "Hunter Helmet",
  7524: "Mage Helmet",
  7525: "Summoner Helmet",
  7526: "Universal Boots",
  7527: "Universal Gloves",
  7528: "Universal Belt",
  7529: "Universal Cloak",
  7530: "Misc Accessory",
  7531: "Ring",
  7532: "Earring",
  7533: "Necklace",
  7534: "Face",
  7535: "Beard",
  7536: "Bag",
  7537: "Boost Chip",
  7538: "Soul Stone",
  7539: "Consumable Cash Item",
  7540: "Bound Cash Item",
  7541: "Consumable Cash Item",
  7542: "Decorative Weapon",
  7543: "Decorative Shield",
  7544: "Decorative Costume",
  7545: "Decorative Helmet",
  7546: "Decorative Glove",
  7547: "Decorative Boots",
  7548: "Decorative Cloak",
  7549: "Decorative Shoulder Piece",
  7550: "Decorative Hair",
  7551: "Decorative One Handed Sword",
  7552: "Decorative Two Handed Sword",
  7553: "Decorative Dagger",
  7554: "Decorative Two Handed Spear",
  7555: "Decorative Two Handed Axe",
  7556: "Decorative One Handed Mace",
  7557: "Decorative Two Handed Mace",
  7558: "Decorative Longbow",
  7559: "Decorative Shortbow",
  7560: "Decorative Crossbow",
  7561: "Decorative One Handed Staff",
  7562: "Decorative Two Handed Staff",
  7563: "Decorative One Handed Axe",
  7564: "Attribute Effect",
  7565: "Attribute Effect P.Atk Enhance",
  7566: "Attribute Effect M.Atk Enhance",
  7567: "Attribute Effect Two Handed P.Atk Enhance",
  7568: "Attribute Effect Two Handed M.Atk Enhance",
  7569: "Warrior Boots",
  7570: "Hunter Boots",
  7571: "Magician Boots",
  7572: "Summoner Boots",
  7573: "Warrior Gloves",
  7574: "Hunter Gloves",
  7575: "Magician Gloves",
  7576: "Summoner Gloves",
  7577: "Warrior Belts",
  7578: "Hunter Belts",
  7579: "Magician Belts",
  7580: "Summoner Belts",
  8002: "P. Atk. #@atk@#<BR>",
  8003: "M. Atk. #@matk@#<BR>",
  8004: "Accuracy #@hit@#<BR>",
  8005: "Atk Spd #@a_speed@#<BR>",
  8006: "P. Def. #@def@#<BR>",
  8007: "M. Def. #@mdef@#<BR>",
  8008: "Avoidance Increase #@avoid@#<BR>",
  8009: "Mov Spd #@mov_speed@#<BR>",
  8010: "Block Per #@block chance@#<BR>",
  8011: "Max. Weight #@maxWT@#<BR>",
  8012: "Block Def #@block defence@#<BR>",
  8013: "#@M_speed@#",
  8014: "#@M_hit@#",
  8015: "#@M_avoid@#",
  8016: "#@Skill_recasting@#",
  8017: "No. of slots #@Belt_Slot@#<BR>",
  8018: "Max HP #@MaxHP@#<BR>",
  8019: "Max MP #@MaxMP@#<BR>",
  8020: "MPRegeneration Quantity #@MP_regen@#<BR>",
  8021: "#@MaxStamina@#",
  9775: "Crit Rate",
  9778: "Perf. Block",
  9779: "P. Ignore",
  9780: "M. Ignore",
  9781: "P. Pierce",
  9782: "M. Pierce",
  9791: "P. Ignore %",
  9792: "M. Ignore %",
  9793: "P. Pierce %",
  9794: "M. Pierce %",
  90610642: "Max HP/MP"
};

export const optNames = {
  96: {
    1: "7101",
    2: "7102",
    4: "7103",
    8: "7104",
    16: "7105",
    32: "7106",
    64: "7107",
    128: "7108",
    256: "7109",
    512: "7110",
    1024: "7111",
    2048: "7112",
    4096: "7113",
    8192: "7114",
    16384: "7115",
    32768: "7116",
    65536: "7117",
    131072: "7118",
    262144: "7119",
    524288: "7120",
    1048576: "7121",
    2097152: "7122",
    4194304: "7123",
    8388608: "7124",
    16777216: "7125",
    33554432: "7126",
    67108864: "7127",
    134217728: "7128",
    268435456: "7129",
    536870912: "7152",
    1073741824: "7130"
  },
  97: {
    1: "7131",
    2: "7132",
    4: "7133",
    8: "7134",
    16: "7135",
    32: "7136",
    64: "7137",
    512: "9778",
    1024: "9779",
    2048: "9780",
    4096: "9781",
    8192: "9782",
    16384: "7138",
    32768: "7139",
    65536: "7140",
    131072: "7141",
    262144: "7142",
    524288: "7143",
    1048576: "7144",
    2097152: "7145",
    4194304: "7146",
    8388608: "7147",
    16777216: "7148",
    33554432: "7149",
    67108864: "7150",
    134217728: "7151",
    268435456: "7152"
  }
};

export const baseVarNames = {
  11: "8002",
  12: "8003",
  13: "8004",
  14: "8005",
  15: "8006",
  16: "8007",
  17: "8008",
  18: "8009",
  19: "8010",
  20: "8011",
  21: "8012",
  22: "8013",
  23: "8014",
  24: "8015",
  25: "8016",
  26: "8017",
  27: "9000",
  30: "8018",
  31: "8019",
  33: "8020",
  35: "7238",
  36: "7239",
  37: "7240",
  38: "7241",
  39: "7242"
};
